export const COMPANY = {
    NAME: 'AurumTours GmbH',
    ADDRESS_LEJ_STREET: 'Querstraße 11',
    ADDRESS_LEJ_CITY: '04103 Leipzig',
};

export const BASE_URL = process.env.VITE_BASE_URL;
export const WEBSITE_URL = process.env.VITE_WEBSITE;
